/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    getClientDireccionesFacturacion: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/' + data.client_id + '/facturaciones', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createClientDireccionesFacturacion: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('clients/' + data.cliente_id + '/facturaciones', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteClientDireccionesFacturacion: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('clients/' + data.cliente_id + '/facturaciones/' + data.direccion_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateClientDireccionesFacturacion: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('clients/' + data.cliente_id + '/facturaciones/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    setDefaultDireccionFacturacion: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.post('clients/' + data.cliente_id + '/facturaciones/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ClientDireccionesModule.js